/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { DurationEnum } from '../models/DurationEnum';
import { EntitlementEnum } from '../models/EntitlementEnum';
import { HttpFile } from '../http/http';

export class StripeProductMetadata {
    'duration': DurationEnum;
    'entitlement': EntitlementEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "duration",
            "baseName": "duration",
            "type": "DurationEnum",
            "format": ""
        },
        {
            "name": "entitlement",
            "baseName": "entitlement",
            "type": "EntitlementEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return StripeProductMetadata.attributeTypeMap;
    }

    public constructor() {
    }
}



